var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.lecture),function(ref,ind){
var ref_title = ref.title;
var title = ref_title[0];
var subtitle = ref_title[1];
var link = ref.link;
return _c('v-col',{key:ind,attrs:{"cols":"12"}},[_c('v-sheet',{attrs:{"tile":"","color":"grey lighten-4"}},[_c('v-container',{staticClass:"article px-4 py-6",on:{"click":function($event){return _vm.goto(link)}}},[_c('p',{staticClass:"mb-0",domProps:{"textContent":_vm._s(title)}}),(subtitle !== undefined)?_c('p',{staticClass:"subtitle mb-0 grey--text",domProps:{"textContent":_vm._s(subtitle)}}):_vm._e()])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }